import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponentTablePromo from "./DataComponent__TablePromo";

const DataComponentBodyPromo = ({
    displayControl,
    data,
    headerNames,
    multiLevelHeaderNames,
    columnData,
    loading,
    settings,
    settingKey,
    filters,
    className
}) => {
    const getRenderComponent = () => {
        const dataItem = displayControl.data.find(item => item.type === displayControl.type);
        const Component = dataItem.component;

        if (React.isValidElement(Component)) {
            return Component;
        } else {
            return (
                <Component
                    data={data}
                />
            );
        }
    };

    const renderTable = () => {
        return (
            <DataComponentTablePromo
                data={data}
                headerNames={headerNames}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    };

    return (
        displayControl
            ? !displayControl.type || displayControl.type === 'table'
                ? renderTable()
                : getRenderComponent()
            : renderTable()
    );
};

DataComponentBodyPromo.propTypes = {
    displayControl: PropTypes.shape({
        type: PropTypes.string,
        data: PropTypes.array
    }),
    data: PropTypes.array,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string
};

DataComponentBodyPromo.defaultProps = {
    displayControl: null,
    data: [],
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {},
    loading: false,
    settings: false,
    settingKey: '',
    filters: {},
    className: ''
};

export default withTranslation(DataComponentBodyPromo);